import { formatUnits, parseUnits } from '@ethersproject/units';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import type { GardenType } from '@ui/utils/garden';
import { getLpUsdValue } from '@ui/utils/garden';
import { useEffect, useRef, useState } from 'react';

import { useCoinMode } from './useCoinMode';

const useLpUsdValue = (type: GardenType, amount: string) => {
  const coinMode = useCoinMode();
  const sdk = useVenoSDK();
  const [lpUsdValue, setLpUsdValue] = useState<number | undefined>(undefined);
  const done = useRef(false);

  useEffect(() => {
    const fetchValue = async () => {
      done.current = false;
      const val = await getLpUsdValue(coinMode, type, sdk, parseUnits(amount));
      if (!done.current) setLpUsdValue(parseFloat(formatUnits(val)));
    };

    if (amount) {
      setLpUsdValue(undefined);
      fetchValue();
    } else {
      setLpUsdValue(undefined);
    }
    return () => {
      done.current = true;
    };
  }, [type, amount, sdk, coinMode]);

  return lpUsdValue;
};

export default useLpUsdValue;
